import Main from './ReportsMain'
import Financial from './ReportsFinancial'

const Reports = {
  Main,
  Financial,
}

export default Reports
